"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = StatusFactory;

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

function StatusFactory(_ref) {
  var status = _ref.status,
      _ref$form = _ref.form,
      form = _ref$form === void 0 ? 'default' : _ref$form;

  try {
    if (status === 'Active') {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": form === 'default' ? 'status.large' : 'status.small',
        form: form,
        mode: "success"
      }, "\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442");
    } else if (status === 'Moderation') {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": form === 'default' ? 'status.large' : 'status.small',
        form: form,
        mode: "info"
      }, "\u041D\u0430 \u043C\u043E\u0434\u0435\u0440\u0430\u0446\u0438\u0438");
    } else if (status === 'New') {
      return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
        "data-locator": form === 'default' ? 'status.large' : 'status.small',
        form: form,
        mode: "primary"
      }, "\u041D\u043E\u0432\u044B\u0439");
    }

    return /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
      "data-locator": form === 'default' ? 'status.large' : 'status.small',
      form: form
    }, "\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D");
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}